export enum memberProspectEnum {
  NonMember = 0,
  Member = 1,
  Prospect = 2,
}
